import { routes } from "../constants/routes"

const findMatchingRoute = (pathname) => {
  for (const route of routes) {
    if (route.path === pathname) {
      return route
    }
    if (route.routes) {
      const nestedMatch = findMatchingRoute(pathname, route.routes)
      if (nestedMatch) return nestedMatch
    }
  }
  return null
}

export const generateBreadcrumbs = (pathname) => {
  const paths = pathname.split('/').filter(Boolean)
  const breadcrumbs = []
  
  let currentPath = ''
  for (const segment of paths) {
    currentPath += `/${segment}`
    const matchingRoute = findMatchingRoute(currentPath, routes)
    
    if (matchingRoute && matchingRoute.breadcrumb) {
      breadcrumbs.push({
        path: currentPath,
        breadcrumb: matchingRoute.breadcrumb
      })
    }
  }
  
  return breadcrumbs
}

export const getTitleFromPathname = (pathname) => {
  const crumbs = generateBreadcrumbs(pathname, routes);
  if (!crumbs.length) return null;
  const lastCrumb = crumbs[crumbs.length - 1];
  return lastCrumb.breadcrumb;
};